import requestManager from "@comp/platformApi/requestManager";
import appHelper from "@util/appHelper";

export default {

    /**
     * @param   {String} code
     * @param   {Function} callback
     */
    getAgreement : function(code, callback) {
        requestManager.request({
            url: 'portal/about/get_Agreement',
            data: {
                code : code
            }
        }, (error, result) => {
            if (error)
            {
                appHelper.generalAjaxError(error);
                return;
            }

            if (result.errorCode)
            {
                appHelper.showHint(result.msg);
                return;
            }

            callback(result.data);
        });
    },

    /**
     * @param   {String} key
     * @param   {Function} callback
     */
    getResource : function(key, callback) {
        requestManager.request({
            url: '/portal/about/getResource',
            data: {
                key : key
            }
        }, (error, result) => {
            if (error)
            {
                appHelper.generalAjaxError(error);
                return;
            }

            if (result.errorCode)
            {
                appHelper.showHint(result.msg);
                return;
            }

            callback(result.data);
        });
    }
};
